
import { translations } from "./translations"; 

export const translatedText = (translationKey) => {
    const locale =
      typeof window !== 'undefined' && window.Shopify?.locale
        ? window.Shopify.locale
        : 'en';
    const base = locale.split('-')[0];
  
    return (
      translations?.[translationKey]?.[base] ||
      translations?.[translationKey]?.['en'] ||
      translations?.[translationKey]?.['default'] ||
      translationKey
    );
  };
  